module.exports = __webpack_public_path__ + "static/fipcbunnymeadow-23c36f290c6b4fd7f80e31b5f3ca0292.jpeg";